import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import amazonLogo from '../assets/amazon.svg';
import jumiaLogo from '../assets/jumia.svg';
import noonLogo from '../assets/noon-2 2.svg';
import trendyolLogo from '../assets/trendyol.svg';

import useScrollAnimation from '../hooks/useScrollAnimation';

const Partners = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const observe = useScrollAnimation();

  const partners = [
    {
      id: 1,
      name: 'Trendyol',
      logo: trendyolLogo,
      width: 120,
      height: 41,
      badge: t.trendyolPartnerBadge,
      url: 'https://www.trendyol.sa/',
    },
    {
      id: 2,
      name: 'Jumia',
      logo: jumiaLogo,
      width: 100,
      height: 61,
      badge: t.jumiaPartnerBadge,
      url: 'https://www.jumia.com.eg/ar/?srsltid=AfmBOoqGGZDNYTLC--ekWQNIG1ZTYGVnHrjQXhvHVZ21NoBAgfNII4rm',
    },
    {
      id: 3,
      name: 'نون',
      logo: noonLogo,
      width: 100,
      height: 39,
      badge: t.noonPartnerBadge,
      url: 'https://www.noon.com/egypt-en/?utm_source=C1000088L&utm_medium=cpc&utm_campaign=C1000151355N_eg_en_web_searchxxexactandphrasexxbrandpurexx08082022_noon_web_c1000088l_acquisition_sembranded_&gad_source=1&gad_campaignid=17997274048&gbraid=0AAAAADH71hijAEgcxrekvWLQXoJtOdWZV&gclid=CjwKCAjw3ejRBhAdEiwADkqPnx99S_djbZXBuLyMTQfl45TpcUyp4oWYptjYoBGnaEbfUtf0B51RaRoCRkgQAvD_BwE',
    },
    {
      id: 4,
      name: 'Amazon',
      logo: amazonLogo,
      width: 120,
      height: 37,
      badge: t.amazonPartnerBadge,
      url: 'https://sellercentral.amazon.com/gspn/provider-details/Training/ebfe81a2-8a6f-48c9-a921-a560638b57a9?ref_=sc_gspn_trlst_trdt-ebfe81a2&localeSelection=en_US&sellFrom=US&sellIn=US',
    },
  ];

  return (
    <section className="py-16 bg-surface-section border-b border-edge-light">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span
            ref={observe}
            className="animate-fade-up inline-flex items-center justify-center px-6 py-2 rounded-full bg-badge text-primary-dark text-sm sm:text-base font-bold font-almarai mb-4"
          >
            {t.integrationTitle}
          </span>

          <h2
            ref={observe}
            className="animate-fade-up text-center mx-auto mb-4 text-heading"
            style={{
              fontFamily: 'IBM Plex Sans Arabic, sans-serif',
              fontWeight: 700,
              fontSize: 'clamp(22px, 4vw, 32px)',
              lineHeight: '130%',
              letterSpacing: '0%',
              transitionDelay: '0.1s',
            }}
          >
            {t.integrationSubtitle}
          </h2>

          <p
            ref={observe}
            className="animate-fade-up text-center mx-auto max-w-3xl text-body-muted"
            style={{
              fontFamily: 'Almarai, sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '145%',
              letterSpacing: '0.5%',
              transitionDelay: '0.2s',
            }}
          >
            {t.integrationDescription}
          </p>
        </div>
      </div>

      <div
        ref={observe}
        className="animate-fade-up w-full bg-badge-strip border-y-2 border-badge py-8"
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="grid grid-cols-2 md:grid-cols-4 items-center justify-items-center gap-8 sm:gap-10 md:gap-12 lg:gap-16"
          >
            {partners.map((partner) => (
              <a
                key={partner.id}
                href={partner.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex flex-col items-center justify-center p-3 rounded-xl transition-all duration-300 hover:scale-105 group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 text-center"
              >
                <div className="h-14 flex items-center justify-center mb-3">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    loading="lazy"
                    width={partner.width}
                    height={partner.height}
                    style={{ width: partner.width, height: 'auto' }}
                    className="object-contain transition-opacity duration-300"
                  />
                </div>
                <span className="font-almarai text-xs sm:text-sm font-semibold text-heading group-hover:text-primary transition-colors leading-tight max-w-[200px]">
                  {partner.badge}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
